import React, { useEffect, useState } from "react";
import Cardd from "../../ui/Card";
import axios from "axios";
import { useFetchData } from "../../hooks/useFetchData";

function Myposts() {
  const [datacard, setDatacard] = useState(null);
  const {
    data: data2,
    isLoading: isLoading2,
    error: error2,
  } = useFetchData(
    "http://3dfinal.tanaghomtech.com/public/api/units?filter[post.user_id]=1&sort=-created_at"
  );
  return (
    <div>
    <div className="container">
      <h2 style={{ textAlign: "center" }}>My Posts</h2>
      <div className="row" style={{ textAlign: "center",
            borderRadius: "8px",
            padding: "16px",
                      
            boxshadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
            margin:'0 auto'}}>
        {(datacard?.data?.length > 0 ? datacard?.data : data2?.data || []).map(
          (i, index) => (
            <div style={{textAlign:'center'}} className="col-md-4 col-sm-12" key={i.id || index} size={6}>
              <Cardd data={i} />
            </div>
          )
        )}
      </div>
    </div></div>
  );
}

export default Myposts;
